import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './Hero.css';
import './Interface.css';

const Hero = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const images = [
    { src: '/images/interface/Amal - 1.png', title: 'ہوم اسکرین' },
    { src: '/images/interface/Amal - 2.png', title: 'روزانہ کا پیغام' },
    { src: '/images/interface/Amal - 3.png', title: 'قرآن پاک' },
    { src: '/images/interface/Amal - 4.png', title: 'سنت نبوی' },
    { src: '/images/interface/Amal - 5.png', title: 'احادیث مبارکہ' },
    { src: '/images/interface/Amal - 6.png', title: '7 منٹ عبادت' },
    { src: '/images/interface/Amal - 7.png', title: 'ایک رکوع' },
    { src: '/images/interface/Amal - 8.png', title: 'گروپ' },
    { src: '/images/interface/Amal - 9.png', title: 'پروفائل' },
    { src: '/images/interface/Amal - 10.png', title: 'ترتیبات' },
    { src: '/images/interface/Amal - 11.png', title: 'مزید' },
  ];

  const nextSlide = () => {
    setActiveIndex((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setActiveIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <section className="hero">
      {/* Background Pattern */}
      <div className="hero-bg">
        <div className="hero-pattern"></div>
        <div className="hero-gradient"></div>
      </div>

      <div className="container">
        {/* Carousel View */}
        <div className="gallery-carousel-wrapper">
          <button className="nav-btn nav-prev" onClick={prevSlide}>
            <ChevronRight size={28} />
          </button>

          <div className="gallery-carousel">
            <div className="gallery-card-single">
              <img src={images[activeIndex].src} alt={images[activeIndex].title} loading="lazy" />
            </div>
          </div>

          <button className="nav-btn nav-next" onClick={nextSlide}>
            <ChevronLeft size={28} />
          </button>
        </div>

        {/* Dots */}
        <div className="gallery-dots">
          {images.map((_, index) => (
            <button
              key={index}
              className={`gallery-dot ${index === activeIndex ? 'active' : ''}`}
              onClick={() => setActiveIndex(index)}
            />
          ))}
        </div>

        {/* Mobile Nav Buttons */}
        <div className="gallery-nav-mobile">
          <button className="nav-btn" onClick={prevSlide}>
            <ChevronRight size={22} />
          </button>
          <button className="nav-btn" onClick={nextSlide}>
            <ChevronLeft size={22} />
          </button>
        </div>
      </div>

      {/* Wave Bottom */}
      <div className="hero-wave">
        <svg viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path d="M0 50L48 45.7C96 41.3 192 32.7 288 30.2C384 27.7 480 31.3 576 40.8C672 50.3 768 65.7 864 67.3C960 69 1056 57 1152 50.8C1248 44.7 1344 44.3 1392 44.2L1440 44V100H1392C1344 100 1248 100 1152 100C1056 100 960 100 864 100C768 100 672 100 576 100C480 100 384 100 288 100C192 100 96 100 48 100H0V50Z" fill="white"/>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
